import { styled } from "@mui/material";
import { EditContext } from "./EditableTable";
import { useContext, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Input = styled("input")(props => ({ border: "none", paddingTop: 4, paddingBottom: 4, paddingLeft: 6, paddingRight: 6, fontSize: "0.9rem", flex: 1, width: "auto", wordWrap: "break-word", wordBreak: "break-all", height: "100%" }));
export function EditCell(props) { const ctx = useContext(EditContext); const initial = props.row[props.field]; const [value, setValue] = useState(initial); const update = input => { ctx.upsert(Object.assign({}, props.row, { [props.field]: value }), { tab: input }); }; return /*#__PURE__*/ _jsx("div", { style: { display: "flex" }, children: /*#__PURE__*/ _jsx("form", { style: { display: "flex", flex: 1 }, onSubmit: e => { e.preventDefault(); update("submit"); }, children: /*#__PURE__*/ _jsx(Input, { ref: r => { r === null || r === void 0 ? void 0 : r.focus(); }, value: value, onChange: e => setValue(e.target.value), onKeyDown: e => { switch (e.key) {
                case "Tab":
                    e.preventDefault();
                    if (e.shiftKey) {
                        update("backward");
                    }
                    else {
                        update("forward");
                    }
                    break;
                case "ArrowLeft":
                    if (e.currentTarget.selectionStart === 0) {
                        update("backward");
                    }
                    break;
                case "ArrowRight":
                    console.log(e.currentTarget.selectionEnd);
                    if (e.currentTarget.selectionEnd === value.length) {
                        update("forward");
                    }
                    break;
                case "ArrowUp":
                    update("up");
                    break;
                case "ArrowDown":
                    update("down");
                    break;
            } }, onBlur: () => update(null) }) }) }); }
